import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Option } from '../report-menu-itau/reports.service'
import { FormBuilder, FormControl, Validators } from '@angular/forms'
import { DateUtils } from 'src/app/services/date.util'
import { FileSaverService } from 'ngx-filesaver'
import { PartnersId } from 'src/shared/util'
import { HttpStatus } from 'src/app/services/get-async.util'
import { calculateDateLimit, formatMonthYear, calculateEndDate } from 'src/app/services/date.util'
import { Venue } from '../../venue-management/venues.interface'
import { ReportsEsferaService } from '../report-menu-esfera/reports.service'
import { ReportEsferaAmenitiesConverted } from '../report-menu-esfera/report.interface'

@Component({
	selector: 'app-report-export',
	templateUrl: './report-export.component.html',
	styleUrls: ['./report-export.component.scss'],
})
export class ReportExportEsferaComponent implements OnInit {
	public idSector = 0
	public filterMonth = false
	public datePeriod = true
	public filterCardAndRest = false
	public searchTab = true
	public options = this.reportsService.options
	public selectedOption: Option = this.options[0]
	public status: HttpStatus = 'idle'
	public tabRestAndCard = [
		{ title: 'Ações restaurante', id: 'restaurant' },
		{ title: 'Reserva cartão', id: 'card' },
	]
	public periods = [
		{ title: 'Período inicial', icon: 'tagmeicon tagmeicon-calendario-24', function: 'firstPeriod' },
		{ title: 'Período final', icon: 'tagmeicon tagmeicon-calendario-24', function: 'endPeriod' },
	]
	public report: ReportEsferaAmenitiesConverted[] | null = null
	public reportFiltered: ReportEsferaAmenitiesConverted[] | null = null
	public reportWithoutGroup: ReportEsferaAmenitiesConverted[] | null = null
	public monthYear = ''
	public dateLimit!: Date
	public endDate = ''

	venues: Venue[] = []
	venueSelected: Venue | undefined
	searchControl = new FormControl('')
	hasVenues: boolean = false

	form = this.fb.nonNullable.group({
		startDate: [
			DateUtils.getPreviousMonthDates().startDate.toISOString().substring(0, 10),
			[Validators.required],
		],
		endDate: [
			DateUtils.getPreviousMonthDates().endDate.toISOString().substring(0, 10),
			[Validators.required],
		],
		venueName: [],
		lote: [],
	})

	constructor(
		private activatedRoute: ActivatedRoute,
		private reportsService: ReportsEsferaService,
		private fb: FormBuilder,
		private fileSaverService: FileSaverService,
	) { }

	ngOnInit(): void {
		const slug = this.activatedRoute.snapshot.paramMap.get('slug')
		this.selectedOption = this.options.find(option => option.slug === slug) ?? this.options[0]
	}

	handleDownloadCsv() {
		this.status = 'pending'
		this.reportsService
			.chooseReportToCall(
				this.selectedOption.slug,
				{
					startDate: this.form.controls.startDate.value,
					endDate: this.form.controls.endDate.value,
					partnerId: PartnersId.ESFERA,
				},
				'csv'
			)
			?.subscribe({
				next: (res: any) => {
					this.status = 'resolved'
					this.fileSaverService.save(res, `${this.selectedOption.slug}.csv`)
				},
				error: () => {
					this.status = 'rejected'
				},
			})
	}

	handlePreviewJson() {
		this.assignEndDate()
		this.status = 'pending'

		const reportData = {
			startDate: this.form.controls.startDate.value,
			endDate: this.form.controls.endDate.value,
			partnerId: PartnersId.ESFERA,
		}

		this.reportsService.chooseReportToCall(this.selectedOption.slug, reportData, 'json')?.subscribe({
			next: res => {
				this.status = 'resolved'
				this.report = res
				this.reportFiltered = res
			},
			error: () => {
				this.status = 'rejected'
			},
		})
	}

	private assignEndDate() {
		const endDate = new Date(this.form.controls.endDate.value)
		this.dateLimit = calculateDateLimit(new Date())
		this.monthYear = formatMonthYear(endDate)
		this.endDate = calculateEndDate(new Date(), this.selectedOption.slug)
	}
}
